import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Carousel, Button, Progress } from 'antd'
import { getDashboardMessage, DashboardData } from "../../../../services/message"

import 'antd/dist/antd.css'
import './bankInfo.scss'

import bankLogo from 'assets/images/logo.png'
import location from 'assets/images/icons/Vector.png'
import login01 from 'assets/images/login01.jpg'
import login1 from 'assets/images/login1.png'
import login2 from 'assets/images/login2.png'
import login3 from 'assets/images/login3.png'
import picture1 from 'assets/images/Picture1.png'
import picture2 from 'assets/images/Picture2.png'
import picture3 from 'assets/images/Picture3.png'
import call from 'assets/images/icons/call.png'
import appstore from 'assets/images/appstore.png'
import googlplay from 'assets/images/googleplay.png'

import { WhatsApp } from '@mui/icons-material'

import carouselData from './carouselData.json'
import { connect } from 'react-redux'
import CustomTooltip from "components/Tooltip";
import { useTranslation } from 'react-i18next'
import { useActions } from "hooks/useActions";
import { getMessageLists } from "store/actions/home";
import { getGoogleAuth, removeNotification } from "store/actions/login";
import { Link } from "react-router-dom";
import moment from 'moment'

const BankInfo: React.FC<any> = ({ lang, messageList }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState([])
  const { getMessageLists } = useActions()
  const language = localStorage.getItem("i18nextLng")


  const [textArray, setTextArray] = useState([])
  useEffect(() => {
    getDashboardMessage()
    getMessageLists()
    const fetchessageData = async () => {
      const message = await getDashboardMessage()
      if (message?.messageText !== undefined && message?.messageText !== null && message?.messageText !== "") {

      }

    };

    fetchessageData();


  }, [])

  useEffect(() => {

    const fetchessageData = async () => {

      let dashboard = messageList?.result !== undefined ? (language == "az" ? messageList.result.find(text=>text.messageKey === 'INFO.WELLCOME')?.textAZE :
        language == "ru" ? messageList.result.find(text=>text.messageKey === 'INFO.WELLCOME')?.textRU : language == "en" ? messageList.result.find(text=>text.messageKey === 'INFO.WELLCOME')?.textENG : null) : null;

      let lang_text = messageList?.result !== undefined ? (language == "az" ? messageList.result.find(text=> text.messageKey === 'INFO.WHATSAPP')?.textAZE :
        language == "ru" ? messageList.result.find(text=> text.messageKey === 'INFO.WHATSAPP')?.textRU : language == "en" ? messageList.result.find(text=> text.messageKey === 'INFO.WHATSAPP')?.textENG : "") : null;

      const array = lang_text !== null && lang_text !== undefined  ? lang_text.split("https://wa.me/") : [];
      const arrayDashboard = dashboard !== null && dashboard !== undefined ? dashboard.split("|") : [];
      setMessage(arrayDashboard)
      setTextArray(array);
    };

    fetchessageData();


  }, [messageList, language])



  const NumbersDropDown = () => {
    return (
      textArray.map((line: any, index: number) => {
        return (
          line.startsWith('994') ?
            `<a href=${'https://wa.me/' + line}  key=${index} > ${"0" + line.substring(3)} </a> 
                        <br/>`
            :
            `<p key=${index}> ${line} </p>`
        )

      }).join(''))
  }

  return (
    <>

      <Carousel {...carouselData.settings}
        effect="fade"
        easing="ease-in-out">
        <div>
          <img src={login01}></img>
        </div>
        <div>
          <img src={login1}></img>
        </div>
        <div>
          <img src={login2}></img>
        </div>
        <div>
          <img src={login3}></img>
        </div>
        <div>
          <img src={picture1}></img>
        </div>
        <div>
          <img src={picture2}></img>
        </div>
        <div>
          <img src={picture3}></img>
        </div>
      </Carousel>
      <div className="left-side">
        <Row align="top">
          <Col lg={14} xl={14} xxl={16}>
            <div className="logo">
              <img src={bankLogo} alt="bank logo" />
            </div>
          </Col>
          {message?.length > 0 &&
            <Col lg={10} xl={10} xxl={8}>
              <Card style={{ wordBreak: "break-word" }} size="small" className="left-side__card">
                <h5>{t("login.attention")}</h5>
                <p>
                  {message.map((line: any, index: number) => {
                    return line.startsWith('http') ? <a href={line}>{line}</a> : line
                  })
                  }
                </p>
              </Card>
            </Col>
          }
        </Row>
        <Row className="left-side__footer">
          <Col span={20} className="left-side__list">
            <ul>
              <li>
                <img src={location} />
                <a target="_blank" href={`http://www.bankrespublika.az/${lang}/branches`}>
                  {t("login.atmBranches")}
                </a>
              </li>
              <li>
                <a target="_blank" href={`http://www.bankrespublika.az/uploads/pdfs/Tarifler%20%28huquqi_sexsler%29_${lang}.pdf`}>
                  {t("login.tariffs")}
                </a>
              </li>
              <li>
                <img src={call} alt="call" />
                144
              </li>
              <div className='displayNone'>2-04-2025</div>
            </ul>
            {/*<ul className="mt-15 storeIcons">*/}
            {/*  <li>*/}
            {/*    {' '}*/}
            {/*    <a target="_blank" href="http://apps.apple.com/az/app/mobil-şöbə/id1098662523?mt=8">*/}
            {/*      <img src={appstore} alt="appstore" />*/}
            {/*    </a>*/}
            {/*  </li>*/}
            {/*  <li>*/}
            {/*    {' '}*/}
            {/*    <a target="_blank" href="http://play.google.com/store/apps/details?id=com.brmobilshobe&hl=ru">*/}
            {/*      <img src={googlplay} alt="googleplay" />*/}
            {/*    </a>*/}
            {/*  </li>*/}
            {/*</ul>*/}
          </Col>
          <Col span={4}>

            <CustomTooltip title={NumbersDropDown()} placement={'top'} className={'wp_tooltips'}>
              <Button
                className="wp_ico flex justify_center align_center icon-login"
                icon={<WhatsApp />}
              />
            </CustomTooltip>

          </Col>
        </Row>
      </div>
    </>
  )
}

const mapDispatchToProps = { getMessageLists }
const mapStateToProps = (state: any) => ({
  lang: state.login && state.login.lang,
  messageList: state.home.messageList,
})
export default connect(mapStateToProps, mapDispatchToProps)(BankInfo)

